import VConsole from 'vconsole'
import 'zepto' /*引入zepto库文件*/
import $ from 'jquery' /*引入jquery,每个模块需要jquery都要引一次*/
import './common/polify.js'
// import './modules/listMock.js';                   	 	/*引入列表模拟数据*/
// import './modules/linkMock.js'; 						 	/*引入二级文字链模拟数据*/
// import __modelObj from './modules/pageMock.js'; 	 	 	/*引入模板模拟数据*/
import searchEvent from './modules/searchEvent.js' /*引入 绑定 搜索   事件模块*/
import drawIncnModel from './modules/drawIconModel.js' /*引入 绘制 icon   图标模块*/
import drawBannerModel from './modules/drawBannerModel.js' /*引入 绘制 banner 图模块*/
import drawLinkModel from './modules/drawLinkModel.js' /*引入 绘制 文字链 模块*/
import bindLinkModel from './modules/bindLinkModel.js' /*引入 绑定 文字链 事件模块*/
import drawListModel from './modules/drawListModel.js'
import drawArticleLine from './modules/drawArticleLine.js'
/*引入 绘制 列表   模块*/
import drawBottomBar from './modules/drawBottomBar.js'
import bindBottomBar from './modules/bindBottomBar.js'
import bindListkModel from './modules/bindListModel.js' /*引入 绑定 列表   事件模块*/
import drawTabModel from './modules/drawTabModel.js' /*引入 绘制 tab    模块*/
import bindTabkModel from './modules/bindTabModel.js' /*引入 绑定 tab    事件模块*/
import bindNavModel from './modules/bindNavModel.js' /*引入 绑定 nav   事件模块*/
import drawNavModel from './modules/drawNavModel.js' /*引入 绘制 导航   模块*/
import util from './modules/util.js' /*引入 公共工具    模块*/
import './modules/callWebApp.js' /*唤起58app		   方法*/
import logicLocation from './modules/location.js' /*引入 定位        模块*/
// import lbs from './modules/lbs.js' /*引入 定位        模块*/
import {justOpenMini} from './modules/openMini.js' /*引入 唤起小程序 模块*/
import { initSearchHotWord } from './modules/initSearchHotWord'
import getURLParameter from './common/getURLParameter.js'
import {setExposureForCard} from './common/exposureForCard.js'
import { drawBaiduDialog, eventBindBaiduDialog } from './modules/drawBaiduDialog' /*引入 百度唤起小程序 模块*/
import { initClickReport as initClickReportNew, initReportEvent } from './common/luna_track/clickReport'
import {initExposure,exposureListen} from './common/luna_track/exposure'
import randomString from './common/getGuid.js';
import { drawTtDialog, eventBindTtDialog } from './modules/drawTtDialog' /*引入 头条唤起小程序 模块*/
import getCookie from "./common/getCookie";


if (getURLParameter()['dev'] === 'vconsole') {
    const vConsole = new VConsole();
}

function grayScaleFilter() {
    var grayScaleFilterStartTime = new Date()
    grayScaleFilterStartTime.setDate(4)
    grayScaleFilterStartTime.setHours(0)
    grayScaleFilterStartTime.setMinutes(0)
    grayScaleFilterStartTime.setSeconds(0)
    var grayScaleFilterEndTime = new Date()
    grayScaleFilterEndTime.setDate(4)
    grayScaleFilterEndTime.setHours(23)
    grayScaleFilterEndTime.setMinutes(59)
    grayScaleFilterEndTime.setSeconds(59)
    var now = (new Date).getTime()
    var grayScaleFilterInterval = null
    if (now >= grayScaleFilterStartTime && now < grayScaleFilterEndTime) {
        $('html').addClass('grayScaleFilter')
        grayScaleFilterInterval = setInterval(function(){
            now = (new Date).getTime()
            if (now >= grayScaleFilterEndTime) {
                $('html').removeClass('grayScaleFilter')
                clearInterval(grayScaleFilterInterval)
                grayScaleFilterInterval = null
            }
        }, 1000)
    } else {
        grayScaleFilterInterval = setInterval(function(){
            now = (new Date).getTime()
            if (now >= grayScaleFilterStartTime && now < grayScaleFilterEndTime) {
                $('html').addClass('grayScaleFilter')
            }
            if (now >= grayScaleFilterEndTime) {
                $('html').removeClass('grayScaleFilter')
                clearInterval(grayScaleFilterInterval)
                grayScaleFilterInterval = null
            }
        }, 1000)
    }
}
// $('html').addClass('grayScaleFilter')

$(function() {
    // grayScaleFilter()
    /*初始化页面元素 & 插件*/
    init()
    /*初始化事件绑定*/
    eventBind()
    /**初始化点击事件统计功能 */
    initClickReport()
    const reportInitLog = {
        log:{
            platform:1,
            page_type:getURLParameter()['creativeid'] === '40' ? 1 : 2
        }
    }
    initClickReportNew({initLog:reportInitLog});
    initExposure({initLog:reportInitLog});
    initReportEvent();
    exposureListen();
})

/*页面元素 & 插件初始化方法*/
function init() {
    justOpenMini(['u-2d7xmzyvg3v43nkdq9g'])
    const firstJump = getURLParameter()['firstJump'] || '';
    if (firstJump === '1' && getCookie('jumpAppletUrlBase') && getCookie('jumpAppletUrlBase') !== 'null') {
        if (!getCookie('jumpAppletUrlType')) {
            location.href = `${decodeURIComponent(getCookie('jumpAppletUrlBase'))}${getCookie('jumpAppletUrlQuery', false)}`
        }
    }

    // util.getCookie('spm').includes('u-2h6kyv2z5988m2wxeg') && lbs()
    // 华为快应用渠道去掉定位
    window.hySearchBox !== 1 && logicLocation()
    /*待拼接的整体页面dom*/
    var html = ''
    /*从页面获取__modelObj对象,根据类型拼接不同的模块*/
    window.__modelObj.modelList.forEach(function(model,index) {
        html += getModelDom(model,index)
    })

    html += '<p class="tips-main">主体信息：五八同城信息技术有限公司</p>'
    html += '<p class="tips-phone">客户服务热线：1010-5858</p>'

    html += drawBaiduDialog()

    if (firstJump === '1' && decodeURIComponent(getCookie('jumpAppletUrlBase')) !== 'null') {
        if (getCookie('jumpAppletUrlType') === '1' || getCookie('jumpAppletUrlType') === '2') {
            html += drawTtDialog()
        }
    }

    if(getURLParameter()['creativeid'] === '40'){
        html += drawBottomBar()
    }

    /*向页面添加dom树*/
    $('#modelList')
        .empty()
        .html(html)
    initSearchHotWord()
    /*给所有链接添加埋点*/
    $(document).on('click', '[data-tag]', function() {
        /*给所有链接添加埋点*/
        if (window.clickLog && $(this).data('tag'))
            window.clickLog(
                `from=${$(this).data('tag')}-${window.____json4fe.creativeid}-${
                    window.__modelObj.type
                }`
            )
    })

    eventBindBaiduDialog()

    if (firstJump === '1' && decodeURIComponent(getCookie('jumpAppletUrlBase')) !== 'null') {
        if (getCookie('jumpAppletUrlType') === '1' || getCookie('jumpAppletUrlType') === '2') {
            eventBindTtDialog()
        }
    }
    
    /*icon图标模块 轮播图 初始化*/
    util.initSwiper('.icon-model', {
        pagination: '.swiper-pagination',
        paginationClickable: true
    })
    util.initSwiper('.icon-model-new', {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true //修改swiper的父元素时，自动初始化swiper
    })

    /*1张banner图模块 轮播图 初始化*/
    util.initSwiper('.banner-model-1 .model-box', {
        autoplay: 3000,
        loop: true,
        pagination: '.swiper-pagination',
        paginationClickable: true,
        autoplayDisableOnInteraction: false,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true //修改swiper的父元素时，自动初始化swiper
    })
    /*1列_多图轮播_头图 轮播图 初始化*/
    util.initSwiper('.banner-model-1-top .model-box', {
        autoplay: 3000,
        loop: true,
        pagination: '.swiper-pagination',
        paginationClickable: true,
        autoplayDisableOnInteraction: false
    })

    util.initSwiper('.article-line__swiper-wrap', {
        direction: 'vertical',
        loop: true,
        autoplay: 3000,
        autoplayDisableOnInteraction: false,
        // loopedSlides: 1,
        // // autoHeight: true,
        // direction: 'vertical',
        // // spaceBetween: 20/75*parseFloat($('html').css('fontSize')),
        // // pagination: '.swiper-pagination',
        // // paginationClickable: true,
        // autoplayDisableOnInteraction: false
        // // observer: true, //修改swiper自己或子元素时，自动初始化swiper
        // // observeParents: true //修改swiper的父元素时，自动初始化swiper
    })

    /*如果有列表模块,初始化列表数据*/
    if ($('.list-model').length !== 0) {
        /**
         * 实时feed流优化需求
         * 修改大类页底部推荐位置页面加载就请求接口情况
         * 优化为滚动到距离推荐位容齐100px时请求接口
         */
        window.pageFeedParams = {
            pn: 1, // 页码
            page_id: randomString(), // 每次请求的唯一标识
            canFeed: true, // 是否可以请求下一页(是否到底)
            loading: false, // 是否请求中
            feedTest: null // 是否是feed流实验下(9或15条帖子)
        }

        $('.list-model').each(function(index, item) {
            var activeLabel, listIndex //listIndex 1列列表中当前tab索引
            if (
                $(item).hasClass('list-model-row-1') ||
                $(item).hasClass('list-model-row-2')
            ) {
                activeLabel = $(item).find('.hiddenEle')
            } else if ($(item).hasClass('list-model-tag')) {
                activeLabel = $(item).find('.list-title-active')
            } else {
                /*获取列表当前选中项,默认是第一个*/
                activeLabel = $(item)
                    .find('.list-title span p')
                    .first()
                listIndex = 1 //默认展示第一tab，索引起始值1
            }
            /*初始化列表数据(ajax异步)*/
            drawListModel.list_content(
                $(item).children('.list-content'),
                activeLabel.data('cateid'),
                activeLabel.data('catename'),
                activeLabel.data('num'),
                activeLabel.data('filter'),
                activeLabel.data('liststyle'),
                activeLabel.data('tip'),
                listIndex,
                activeLabel.data('modeltype'),
                activeLabel.data('tag')
            )

            /*获取列表当前选中项,默认是第一个*/
            //var activeLabel = $('.list-model .list-title span p').first();
            /*初始化列表数据(ajax异步)*/
            //drawListModel.list_content(activeLabel.data('cateid'), activeLabel.data('catename'), activeLabel.data('num'), activeLabel.data('listStyle'));
        })
        // judgeShow($('.list-model')[0]).then(() => {

        // });
        $(window).on('scroll', () => {
            const scrollBottomGap = window.pageFeedParams.feedTest ? 420 : 1;

            if(!window.pageFeedParams.loading && window.pageFeedParams.canFeed && $(window).scrollTop() >= $(document).height() - $(window).height() - scrollBottomGap) {
                $('.list-model').each(function(index, item) {
                    var activeLabel, listIndex //listIndex 1列列表中当前tab索引
                    if (
                        $(item).hasClass('list-model-row-1') ||
                        $(item).hasClass('list-model-row-2')
                    ) {
                        activeLabel = $(item).find('.hiddenEle')
                    } else if ($(item).hasClass('list-model-tag')) {
                        activeLabel = $(item).find('.list-title-active')
                    } else {
                        /*获取列表当前选中项,默认是第一个*/
                        activeLabel = $(item)
                            .find('.list-title span p')
                            .first()
                        listIndex = 1 //默认展示第一tab，索引起始值1
                    }
                    ++window.pageFeedParams.pn
                    window.pageFeedParams.loading = true;
                    /*初始化列表数据(ajax异步)*/
                    drawListModel.list_content(
                        $(item).children('.list-content'),
                        activeLabel.data('cateid'),
                        activeLabel.data('catename'),
                        activeLabel.data('num'),
                        activeLabel.data('filter'),
                        activeLabel.data('liststyle'),
                        activeLabel.data('tip'),
                        listIndex,
                        activeLabel.data('modeltype'),
                        activeLabel.data('tag')
                    )
                })
            }
        })
    }
}

/**
 * 根据model.modelType 返回对应模块dom结构
 * */
function getModelDom(model,index) {
    var html = ''
    switch (model.modelType) {
        /*3列 icon 模块*/
    case 'icon_3':
        html = drawIncnModel.icon_3(model,'',index)
            // modelList.append(drawIncnModel.icon_4(model));
        break
        /*4列 icon 模块*/
    case 'icon_4':
        html = drawIncnModel.icon_4(model,'',index)
            // modelList.append(drawIncnModel.icon_4(model));
        break
        /*5列 icon 模块*/
    case 'icon_5':
        html = drawIncnModel.icon_5(model,'',index)
            // modelList.append(drawIncnModel.icon_5(model));
        break
        /*1张图片          banner 模块*/
    case 'banner_1':
        html = drawBannerModel.banner_1(model,'',index)
            // modelList.append(drawBannerModel.banner_1(model));
        break
        /*2张图片          banner 模块*/
    case 'banner_2':
        html = drawBannerModel.banner_2(model,'',index)
        break
        /*3张图片          banner 模块*/
    case 'banner_3':
        html = drawBannerModel.banner_3(model,'',index)
        break
        /*左1右2白底背景图 banner 模块*/
    case 'banner_12_white':
        html = drawBannerModel.banner_12_white(model,'',index)
        break
        /*左1右2纯图片     banner 模块*/
    case 'banner_12_pic':
        html = drawBannerModel.banner_12_pic(model,'',index)
        break
        /*3列纯         文字链 模块*/
    case 'link_3':
        html = drawLinkModel.link_3(model,'',index)
        break
        /*3列白底背景图 文字链 模块*/
    case 'link_3_white':
        html = drawLinkModel.link_3_white(model,'',index)
        break
        /*3列纯图       文字链 模块*/
    case 'link_3_pic':
        html = drawLinkModel.link_3_pic(model,'',index)
        break
        /*左1右2纯图    文字链 模块*/
    case 'link_12_pic':
        html = drawLinkModel.link_12_pic(model,'',index)
        break
        /*4列纯         文字链 模块*/
    case 'link_4':
        html = drawLinkModel.link_4(model,'',index)
        break
        /*4列纯         文字链 模块*/
    case 'link_4_pic':
        html = drawLinkModel.link_4_pic(model,'',index)
        break
        /*4列白底背景图 文字链 模块*/
    case 'link_4_white':
        html = drawLinkModel.link_4_white(model,'',index)
        break
        /*列表 模块*/
    case 'list':
        html = drawListModel.list_container(model,index)
        break
    case 'tab':
        html = drawTabModel(model,index)
        break
        /*导航模块*/
    case 'nav':
        $('body').addClass('body-nav')
        html = drawNavModel.nav(model, getModelDom)
        break
        /*1列_多图轮播_头图          banner 模块*/
    case 'banner_1_top':
        $('body').addClass('body_banner_top')
        $('.lunaSearch .logo img').prop(
                'src',
                '//img.58cdn.com.cn/crop/biz/m/lunaHome/pic/img/logo-white.png'
            )
        html = drawBannerModel.banner_1(
                model,
                'banner-model-new banner-model-1-top',
                index
            )
        break
        /*2列_纯图_banner_含标题 banner 模块*/
    case 'banner_2_title':
        html = drawBannerModel.banner_2_title(model, 'banner-model-new',index)
        break
        /*3列_图文  banner 模块*/
    case 'banner_3_word':
        html = drawBannerModel.banner_3_word(model, 'banner-model-new',index)
        break
        /*4列_图文    banner 模块*/
    case 'banner_4_word':
        html = drawBannerModel.banner_4_word(model, 'banner-model-new',index)
        break
        /*左1右3_纯图         文字链 模块*/
    case 'link_13_pic':
        html = drawLinkModel.link_13_pic(model, 'link-model-new',index)
        break
        /*1行_信息列表  列表 模块*/
    case 'list_1_row':
        html = drawListModel.drawList_1_row_Container(model,index)
        break
        /*2行_单类轮播_信息列表  列表 模块*/
    case 'list_2_row':
        html = drawListModel.drawList_2_row_Container(model,index)
        break
        /*3列纯         文字链 模块*/
    case 'link_1':
        html = drawLinkModel.link_1(model,index)
        break
        /*已有模块 新版样式*/
        /*3列 icon 模块*/
    case 'icon_3_new':
        html = drawIncnModel.icon_3(model, 'icon-model-new',index)
            // modelList.append(drawIncnModel.icon_4(model));
        break
        /*4列 icon 模块*/
    case 'icon_4_new':
        html = drawIncnModel.icon_4(model, 'icon-model-new',index)
            // modelList.append(drawIncnModel.icon_4(model));
        break
        /*5列 icon 模块*/
    case 'icon_5_new':
        html = drawIncnModel.icon_5(model, 'icon-model-new',index)
            // modelList.append(drawIncnModel.icon_5(model));
        break
        /*1张图片          banner 模块*/
    case 'banner_1_new':
        html = drawBannerModel.banner_1(
                model,
                'banner-model-new banner-model-1',
                index
            )
            // modelList.append(drawBannerModel.banner_1(model));
        break
        /*2张图片          banner 模块*/
    case 'banner_2_new':
        html = drawBannerModel.banner_2(
                model,
                'banner-model-new banner-model-2-new',
                index
            )
        break
        /*3张图片          banner 模块*/
    case 'banner_3_new':
        html = drawBannerModel.banner_3(model, 'banner-model-new',index)
        break
        /*左1右2白底背景图 banner 模块*/
    case 'banner_12_white_new':
        html = drawBannerModel.banner_12_white(model, 'banner-model-new',index)
        break
        /*左1右2纯图片     banner 模块*/
    case 'banner_12_pic_new':
        html = drawBannerModel.banner_12_pic(model, 'banner-model-new',index)
        break
        /*3列纯         文字链 模块*/
    case 'link_3_new':
        html = drawLinkModel.link_3(model, 'link-model-new',index)
        break
        /*3列白底背景图 文字链 模块*/
    case 'link_3_white_new':
        html = drawLinkModel.link_3_white(model, 'link-model-new',index)
        break
        /*3列纯图       文字链 模块*/
    case 'link_3_pic_new':
        html = drawLinkModel.link_3_pic(model, 'link-model-new',index)
        break
        /*3列_图文_文字链模块_新 文字链 模块*/
    case 'link_3_pic_word_new':
        html = drawLinkModel.link_3_pic_word_new(model, 'link-model-new',index)
        break
        /*左1右2纯图    文字链 模块*/
    case 'link_12_pic_new':
        html = drawLinkModel.link_12_pic(model, 'link-model-new',index)
        break
        /*4列纯         文字链 模块*/
    case 'link_4_new':
        html = drawLinkModel.link_4(model, 'link-model-new',index)
        break
        /*4列纯         文字链 模块*/
    case 'link_4_pic_new':
        html = drawLinkModel.link_4_pic(model, 'link-model-new',index)
        break
        /*4列白底背景图 文字链 模块*/
    case 'link_4_white_new':
        html = drawLinkModel.link_4_white(model, 'link-model-new',index)
        break
        /*列表 模块*/
    case 'list_new':
        html = drawListModel.list_container(model, 'list-model-new',index)
        break
        /** 1列信息流标签式 */
    case 'list-tag-4':
        html = drawListModel.drawList_tag_Container(model,index)
        break;
    case 'banner_4_pic_scene':
        html = drawBannerModel.drawBanner4PicScene(model,index)
        break;
    case 'banner_2_pic_scene':
        html = drawBannerModel.drawBanner2PicScene(model,index)
        break;
    case 'link-survery':
        html = drawLinkModel.drawLinkSurvery(model,index)
        break;
    case 'article-line':
        html = drawArticleLine(model,index)
		break;
	case 'banner_chunzhan_dynamic':
		html = drawBannerModel.dynamicChunzhan(model,index)
		$('.searchBox .hotSearch').after(`<div class="hotActivity">
			<h2>热门活动</h2>
			${html}
		</div>`)
		break;
    default:
        break
    }
    return html
}

/*事件绑定初始化方法*/
function eventBind() {
    /*搜索   事件绑定*/
    searchEvent()
    /*文字链 事件绑定*/
    bindLinkModel()
    /*列表页 事件绑定*/
    bindListkModel()
    /*tab    事件绑定*/
    bindTabkModel()
    /*nav   事件绑定*/
    bindNavModel()
    bindBottomBar()
}

function initClickReport() {
    $('.lunaSearch > .logo').addClass('clickreport-luna-logo')
    let pageType = __modelObj.type === '聚合' ? 1 : 2
    window.TCB_CLICKREPORT = {
        pageType
    };
    const load = function(options) {
        var ems = document.createElement('script')
        ems.type = 'text/javascript'
        ems.onload = function() {
            if(typeof options.callback === 'function') {
                options.callback()
            }
        }
        ems.src = `${options.url}?${(+new Date(new Date().setHours(0, 0, 0, 0)))}`
        var s = document.getElementsByTagName('script')[0]
        s.parentNode.insertBefore(ems, s)
    }
    // load({
    //     url: '//j1.58cdn.com.cn/crop/ecom/m/exposure-statistic/bundle.js'
    // })
    load({
        url: '//j1.58cdn.com.cn/crop/ecom/m/exposure-statistic/bundle.js',
        callback() {
            var Exposure = new ExposureClass({
                selector:'.visiblereport-luna',
                callback: ({module_id, extralParam} = {}) => {
					const {clickReport: {send, buildExposureDefaultInfo, encodeObjectURIComponent, joinCompleteUrl, pageType} = {}} = window.TCB_CLICKREPORT || {};
                    let _paramsObj = {}
                    if (typeof buildExposureDefaultInfo === 'function') {
                        _paramsObj = buildExposureDefaultInfo()
                    }
                    Object.assign(_paramsObj, {
                        d: {
                            page_type: pageType,
                            element_id: 0,
                            module_id: parseFloat(module_id),
                            element_param: {
                                ...extralParam
                            }
                        }
                    });
                    send(joinCompleteUrl(encodeObjectURIComponent(_paramsObj)));
                }
            });
            setExposureForCard();
        }
    })
}

